import React from "react";
import {CCChart} from "../CCChart";

// Sibling scaffold to CCMuiChart for value-only MUI x-charts components
// (Gauge takes `value`, SparkLineChart takes a flat `data` array). Neither
// uses `series`/`xAxis`/`yAxis`, so seeding those would be dead weight and
// could collide with the chart's own prop validation.
//
// Subclasses provide:
//   static ATTR_MAP — array of [PascalCaseAttr, camelCaseMuiProp] pairs
//   renderChart(chartProps) — returns the MUI element with chartProps spread in
//
// Subclasses also own their data slot in state (e.g. CCGauge sets
// state.Value, CCSparkline sets state.Data) and inject it inside
// renderChart, since the shape differs per chart type.
class CCMuiValueChart extends (CCChart as any) {
    static ATTR_MAP: [string, string][] = [];

    constructor(props: any) {
        super(props);

        this.state.Loading = props.attributes?.Loading;
    }

    renderChart(_chartProps: any): React.ReactNode {
        throw new Error(`${this.constructor.name} must implement renderChart(chartProps)`);
    }

    render(): React.ReactNode {
        const a = this.props.attributes ?? {};
        const muiProps: any = {};
        for (const [src, dst] of (this.constructor as any).ATTR_MAP) {
            if (a[src] !== undefined) muiProps[dst] = a[src];
        }

        // Value-only charts (Gauge, SparkLineChart) don't accept a `loading`
        // prop in MUI v9; if forwarded, it bleeds through to the underlying
        // <svg> and React warns about a non-boolean attribute. Don't pass it.
        return this.renderChart({...muiProps});
    }
}

export default CCMuiValueChart;
